
import { useTranslation } from 'react-i18next';
import { BarChart } from "lucide-react";
import { motion } from "framer-motion";

const BANK_DATA_JA = [
  { rank: 1, name: '南都銀行', ratio: '79.3%' },
  { rank: 2, name: '池田泉州銀行', ratio: '76.2%' },
  { rank: 3, name: '京都銀行', ratio: '76.1%' },
  { rank: 4, name: '但馬銀行', ratio: '73.2%' },
  { rank: 5, name: '百五銀行', ratio: '66.5%' },
  { rank: 6, name: '紀陽銀行', ratio: '63.8%' },
  { rank: 7, name: 'みなと銀行', ratio: '62.5%' },
  { rank: 8, name: '関西みらい銀行', ratio: '59.9%' },
  { rank: 9, name: '滋賀銀行', ratio: '51.5%' },
  { rank: 10, name: '三十三銀行', ratio: '34.5%' },
];

const BANK_DATA_EN = [
  { rank: 1, name: 'Nanto Bank', ratio: '79.3%' },
  { rank: 2, name: 'Ikeda Senshu Bank', ratio: '76.2%' },
  { rank: 3, name: 'The Bank of Kyoto', ratio: '76.1%' },
  { rank: 4, name: 'Tajima Bank', ratio: '73.2%' },
  { rank: 5, name: 'The Hyakugo Bank', ratio: '66.5%' },
  { rank: 6, name: 'The Kiyo Bank', ratio: '63.8%' },
  { rank: 7, name: 'Minato Bank', ratio: '62.5%' },
  { rank: 8, name: 'Kansai Mirai Bank', ratio: '59.9%' },
  { rank: 9, name: 'The Shiga Bank', ratio: '51.5%' },
  { rank: 10, name: 'Sanjusan Bank', ratio: '34.5%' },
];

export const FinancialDataSection = () => {
  const { t, i18n } = useTranslation();
  const BANK_DATA = i18n.language.startsWith('ja') ? BANK_DATA_JA : BANK_DATA_EN;

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.keieisha_hosho.financial_title')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.keieisha_hosho.financial_desc')}
        </p>

        <div className="overflow-x-auto mb-8">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="border-b border-white/20">
                <th className="px-4 py-3 text-left text-[#c9a84c] font-bold text-sm">{t('plans_detail.keieisha_hosho.table_rank')}</th>
                <th className="px-4 py-3 text-left text-[#c9a84c] font-bold text-sm">{t('plans_detail.keieisha_hosho.table_bank')}</th>
                <th className="px-4 py-3 text-left text-[#c9a84c] font-bold text-sm">{t('plans_detail.keieisha_hosho.table_ratio')}</th>
              </tr>
            </thead>
            <tbody>
              {BANK_DATA.map((row) => (
                <tr key={row.rank} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                  <td className="px-4 py-3 text-white/70">{row.rank}</td>
                  <td className="px-4 py-3 text-white/85">{row.name}</td>
                  <td className="px-4 py-3 text-[#c9a84c] font-medium">{row.ratio}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="border border-[#c9a84c]/30 bg-[#c9a84c]/10 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#c9a84c] flex items-center gap-2">
            <BarChart className="h-5 w-5" />
            {t('plans_detail.keieisha_hosho.trend_title')}
          </h3>
          <p className="mb-4 text-white/70 leading-relaxed">
            {t('plans_detail.keieisha_hosho.trend_p1')}
          </p>
          <p className="mb-4 text-white/70 leading-relaxed">
            {t('plans_detail.keieisha_hosho.trend_p2')}
          </p>
          <p className="text-white/70">
            {t('plans_detail.keieisha_hosho.trend_p3')}
          </p>
        </div>
      </motion.section>
    </>
  );
};
